import lazyLoadView from "@router-utils/lazyload-view";
import routeError from "@router-utils/route-error";
import store from '@store'

export default [
  // ===
  // 留言
  // ===
  {
    path: '/comment/:commentId',
    name: 'comment',
    component: () => lazyLoadView(import('@views/Comment/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {

          const [
            currentCommentItem,
          ] = await Promise.all([
            store.dispatch('comment/fetchCommentItem', {
              commentId: routeTo.params.commentId
            }),
          ]);

          routeTo.params.commentItem = currentCommentItem.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
    },
    props: (route) => ({
      commentItem: route.params.commentItem || {},
    }),
  },
]
